import * as yup from "yup";
import {
  createAccessTypeValidation,
  createExpirationDateValidation,
  workspaceAssignmentErrorMessages,
} from "~/pages/UserAndRoles/utils/workspaceAssignmentValidation";

const errorMessages = {
  userIds: "User is required",
  minUsers: "At least one user is required",
  roleGroupName: workspaceAssignmentErrorMessages.roleGroupName,
};

export const validationSchema = yup.object().shape({
  userIds: yup
    .array()
    .of(yup.string())
    .required(errorMessages.userIds)
    .min(1, errorMessages.minUsers),
  roleGroupName: yup.string().required(errorMessages.roleGroupName),
  accessType: createAccessTypeValidation(),
  expirationDate: createExpirationDateValidation(),
});
